/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ChevronNextIcon = /*#__PURE__*/ createSvgIcon(
  'ChevronNextIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.875 10L7.458 6.583a.73.73 0 010-1.062.73.73 0 011.07.007l3.951 3.951a.756.756 0 01.208.525.69.69 0 01-.208.517l-3.951 3.951a.693.693 0 01-.528.226.759.759 0 01-.52-.24.73.73 0 010-1.062L10.874 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ChevronNextIcon;
